import { styled } from '@defa/defa-component-library';

import { Section } from '../app-layout/app-layout.styles';

export const SupportSectionRoot = styled(Section)`
    text-align: center;

    a {
        color: inherit;
    }
`;
